export default __webpack_public_path__ + "static/media/ISFJ-2.36db3c78.png";